import React, { useEffect, useMemo } from 'react';
import {
  ReferenceField,
  FunctionField,
  Datagrid,
  TextField,
  useUnselectAll,
  linkToRecord
} from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import StatusSelectField from '../../core/components/StatusSelectField';
import { withStyles } from '@material-ui/core/styles';
import { userStatus } from '../users/UserLookups';

const styles = () => ({
  statusColumnStyle: {
    width: '68px'
  },
  label: {
    color: '#424242',
    fontSize: '14px',
    display: 'inline-block',
    paddingBottom: '10px'
  },
  expandLabel: {
    color: '#757575',
    fontSize: '14px',
    display: 'inline-block',
    transform: 'translateY(-10px)'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center'
  }
});

const InvestorContactsDatagrid = props => {
  const {
    handleFundClick,
    handleInvestorFundEditButtonClick,
    classes,
    expand,
    permissions,
    ...datagridProps
  } = props;

  //unselecting all the checkboxes from the deleting actions in the ComponenWillUnmount listener
  const unSelectAll = useUnselectAll(datagridProps.resource);

  const hasReadUserPermission = useMemo(() => {
    return permissions.includes('AUTH_READ_USER_NA');
  }, [permissions]);

  useEffect(() => () => unSelectAll(), [unSelectAll]);

  if (props.total > 0) {
    return (
      <>
        {expand && <span className={classes.label}>Related Contacts</span>}
        <Datagrid {...datagridProps}>
          <ReferenceField
            label="Contact Name"
            source="userId"
            reference="users"
            sortBy="firstName"
            link={(record, reference) =>
              hasReadUserPermission
                ? `${linkToRecord(`/${reference}`, record.userId)}`
                : false
            }
          >
            <FunctionField
              label="Contact Name"
              render={record => `${record.firstName} ${record.lastName}`}
            />
          </ReferenceField>
          <TextField label="User ID" source="userId" sortable={false} />
          <TextField label="Email Address" source="email" sortBy="email" />
          <TextField label="Company" source="company" sortBy="company" />
          <StatusSelectField
            label="Status"
            source="status"
            choices={userStatus}
            sortBy="userStatus"
          />
        </Datagrid>
      </>
    );
  } else if (props.loaded) {
    return (
      <span className={expand ? classes.expandLabel : classes.label}>
        There are no related Contacts to be displayed
      </span>
    );
  } else {
    return (
      <div className={classes.progress}>
        <CircularProgress />
      </div>
    );
  }
};

export default withStyles(styles)(InvestorContactsDatagrid);
